<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocf"><a class="xref" href="#/chihart0007#intro">Introduction</a></p>
<p class="tocpt"><a class="xref" href="#/chihart0008#pt01"><span class="sm">PART</span> <span class="sm">1:</span> <span class="sm">THE</span> <span class="sm">EARLY</span> <span class="sm">MODERN</span> <span class="sm">MARKETPLACE</span> <span class="sm">AND</span> <span class="sm">ITS</span> <span class="sm">COLONIAL</span> <span class="sm">ENCOUNTER</span></a></p>
<p class="toc"><a class="xref" href="#/chihart0009#ch01">1   A Journey through Early Modern Trading Spaces</a></p>
<p class="toc"><a class="xref" href="#/chihart0010#ch02">2   The Market Turned Upside Down</a></p>
<p class="tocpt"><a class="xref" href="#/chihart0011#pt02"><span class="sm">PART</span> <span class="sm">2:</span> <span class="sm">REMAKING</span> <span class="sm">THE</span> <span class="sm">MARKETPLACE</span></a></p>
<p class="toc"><a class="xref" href="#/chihart0012#ch03">3   Making a Colonial Marketplace</a></p>
<p class="toc"><a class="xref" href="#/chihart0013#ch04">4   The Resurgence of Early Modern Market Values</a></p>
<p class="tocpt"><a class="xref" href="#/chihart0014#pt03"><span class="sm">PART</span> <span class="sm">3:</span> <span class="sm">CONFRONTING</span> <span class="sm">THE</span> <span class="sm">COLONIAL</span> <span class="sm">MARKETPLACE</span></a></p>
<p class="toc"><a class="xref" href="#/chihart0015#ch05">5   Revolution in the Marketplace</a></p>
<p class="toc"><a class="xref" href="#/chihart0016#ch06">6   Making a Republican Marketplace</a></p>
<p class="toc"><a class="xref" href="#/chihart0017#conc">Conclusion: Constitution Making and the Marketplace</a></p>
<p class="toc"><a class="xref" href="#/chihart0018#epil">Epilogue: The Colonial Marketplace’s American Legacy</a></p>
<p class="tocbmf"><a class="xref" href="#/chihart0019#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chihart0020#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chihart0022#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hart-0006.vue?f48857d8